import React from 'react'
import styled from 'styled-components'

import FeatureBox from './FeatureBox'
import MiscHeading from '@pc/components/Works/Panel/shared/heading/MiscHeading'
import TextInput from '@pc/components/Works/Panel/shared/TextInput'
import type { SearchParamsAttributes } from '@pc/components/Works/Panel/type'

interface PropsType {
  freeWord: SearchParamsAttributes['free_word']
  changeState: (arg: any) => void
}

const FreewordInput = styled(TextInput)`
  height: 40px;
  margin-top: 10px;
  width: 250px;
`

const FreewordBox = (props: PropsType) => {
  const { freeWord, changeState } = props

  const changeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const freeWord = e.target.value
    changeState({ freeWord })
  }

  return (
    <FeatureBox>
      <MiscHeading>フリーワード検索</MiscHeading>
      <FreewordInput type="text" placeholder="(例)渋谷 カフェ" value={freeWord ?? ''} onChange={changeInput} />
    </FeatureBox>
  )
}

export default FreewordBox
